import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, And, Rule, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class WholesalePurchaseCreatedService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  getAutomationNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    if (step?.choices?.rules?.length > 0) {
      const andRules = And.fromRuleInterface(step.choices.rules[0]).value as Rule[];

      const statusFromRule = andRules[0].value
        ? this.translateService.instant('AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.STATUS_SUCCEEDS')
        : this.translateService.instant('AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.STATUS_FAILS');

      if (andRules.length > 1) {
        const orRules = andRules[1].value as Rule[];
        const count = orRules.length - 1;
        return this.nodeDisplayData(
          this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.WHEN_ACTION', {
            approvalState: statusFromRule,
            productName: orRules[0].value,
            plusOthers: count > 0 ? ` (+${count})` : ``,
          }),
          this.noValidationErrorsDetected(),
        );
      } else {
        return this.nodeDisplayData(
          this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.WHEN_ACTION', {
            approvalState: statusFromRule,
            productName: this.translateService.instant(
              'AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.ANY_PRODUCTS',
            ),
            plusOthers: ``,
          }),
          this.noValidationErrorsDetected(),
        );
      }
    } else {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.CONFIG_ERROR'),
        this.validationErrorsDetected(
          step,
          this.translateService.instant('AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.CONFIG_ERROR'),
          true,
        ),
      );
    }
  }

  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    const triggerData = activity?.triggerData ? JSON.parse(activity.triggerData) : {};
    const statusFromRule =
      triggerData.approved === 'true'
        ? this.translateService.instant('AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.STATUS_SUCCEEDED')
        : this.translateService.instant('AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.STATUS_FAILED');
    return this.triggerActivityEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.WHOLESALE_PURCHASE_CREATED.ACTIVITY', {
        approvalState: statusFromRule,
        productName: triggerData.sku,
      }),
    );
  }
}
